import { CreateInstance } from "./config"
const management = CreateInstance("management")
const manager = CreateInstance("manager")
export default { management, manager }
